// Papéis que podem registrar ÁREA (plantio de categoria "Profissional").
//
// O backend é quem decide de verdade (PapelValidation.js recusa com 403); aqui
// é só para a tela não oferecer o que o servidor vai recusar. O papel é
// concedido pelo administrador, por pedido do usuário — não há pagamento nesta
// etapa do sistema.
export const PAPEIS_PROFISSIONAIS = ['Profissional', 'Administrador'];

export function ehProfissional(usuario) {
  return !!usuario && PAPEIS_PROFISSIONAIS.includes(usuario.tipo);
}

// O ambiente administrativo (/admin/*) é separado da jornada do usuário. É só
// navegação: o backend é quem barra de verdade (adminValidation).
export function ehAdministrador(usuario) {
  return usuario?.tipo === 'Administrador';
}
